/**
 * Shared enum constants for project lifecycle / classification fields.
 * These mirror the SQL CHECK constraints in backend/migrations/0097.sql.
 */

import { ProjectStatuses } from 'types/enums'

export const PROJECT_USAGE_VALUES = [
  'training',
  'copy',
  'sample',
  'testing',
  'client',
  'trial',
  'demo',
  'pilot',
  'gold_star',
] as const

export type ProjectUsage = (typeof PROJECT_USAGE_VALUES)[number]

export const PROJECT_DATA_TYPES = [
  'reviews_and_ratings',
  'customer_care',
  'social',
  'survey',
  'interview_transcripts',
  'questions_and_answers',
] as const

export type ProjectDataType = (typeof PROJECT_DATA_TYPES)[number]

export const USAGE_LABELS: Record<ProjectUsage, string> = {
  training: 'Training',
  copy: 'Copy',
  sample: 'Sample',
  testing: 'Testing',
  client: 'Client',
  trial: 'Trial',
  demo: 'Demo',
  pilot: 'Pilot',
  gold_star: 'Gold star',
}

export const DATA_TYPE_LABELS: Record<ProjectDataType, string> = {
  reviews_and_ratings: 'Reviews & Ratings',
  customer_care: 'Customer Care',
  social: 'Social',
  survey: 'Survey',
  interview_transcripts: 'Interview Transcripts',
  questions_and_answers: 'Q&A',
}

export const STATUS_FILTER_OPTIONS: { text: string; value: ProjectStatuses }[] =
  [
    { text: 'Created', value: ProjectStatuses.CREATED },
    { text: 'Preprocessing', value: ProjectStatuses.PREPROCESSING },
    {
      text: 'Preprocessing Update',
      value: ProjectStatuses.PREPROCESSING_UPDATE,
    },
    {
      text: 'Preprocessing Complete',
      value: ProjectStatuses.PREPROCESSING_COMPLETE,
    },
    {
      text: 'Preprocessing Update Complete',
      value: ProjectStatuses.PREPROCESSING_UPDATE_COMPLETE,
    },
    { text: 'Network Processing', value: ProjectStatuses.NETWORK_PROCESSING },
    {
      text: 'Network Processing Update',
      value: ProjectStatuses.NETWORK_PROCESSING_UPDATE,
    },
    { text: 'Network Complete', value: ProjectStatuses.NETWORK_COMPLETE },
    {
      text: 'Network Update Complete',
      value: ProjectStatuses.NETWORK_UPDATE_COMPLETE,
    },
    {
      text: 'Clustering Update Complete',
      value: ProjectStatuses.CLUSTERING_UPDATE_COMPLETE,
    },
    { text: 'Complete', value: ProjectStatuses.COMPLETE },
    { text: 'Error', value: ProjectStatuses.ERROR },
  ]
